import { render, staticRenderFns } from "./DaumPostcodePopup.vue?vue&type=template&id=27823235&"
import script from "./DaumPostcodePopup.vue?vue&type=script&lang=js&"
export * from "./DaumPostcodePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports